import { getShareURL } from 'betterplace-react-components/transpile';
import classNames from 'classnames';
import { CopyText, CopyTextState, Icon } from 'design-system/client';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import styles from './CopyLinkButton.module.css';
function CopyLinkButton({
  shareUrl,
  utmParams,
  onTextCopied,
  onError,
  fadeOutDelay
}: {
  shareUrl: string;
  utmParams?: Record<'utmCampaign' | 'utmMedium', string | string[]>;
  onTextCopied: () => void;
  onError: () => void;
  fadeOutDelay: number;
}) {
  const t = useTranslations('nextjs');
  const label: Record<CopyTextState, string> = useMemo(() => ({
    [CopyTextState.Idle]: t('core.copy_url'),
    [CopyTextState.FadingOut]: t('core.copy_url'),
    [CopyTextState.Success]: t('core.generic_copy_alert'),
    [CopyTextState.Error]: t('core.copy_error')
  }), [t]);
  const textToCopy = getShareURL(shareUrl, {
    utm_campaign: utmParams?.utmCampaign,
    utm_medium: utmParams?.utmMedium,
    utm_source: 'Link'
  });
  return <CopyText textToCopy={textToCopy} onTextCopied={onTextCopied} onError={onError} fadeOutDelay={fadeOutDelay}>
      {(copyText, state) => <button className={classNames(styles.socialSharingButton, styles.link, styles.linkButton, {
      [styles.success!]: state === CopyTextState.Success,
      [styles.error!]: state === CopyTextState.Error
    })} onClick={copyText} aria-live="polite" aria-label={label[state]}>
          <Icon name="link" color="fg-light-primary" size="400" className={styles.copyLink} />
          <Icon name="check" color="fg-light-primary" size="400" className={styles.successFeedback} />
          <Icon name="x" color="fg-light-primary" size="400" className={styles.errorFeedback} />
        </button>}
    </CopyText>;
}
export default CopyLinkButton;